
















import Vue from 'vue'
import {Component, Prop, Provide} from 'vue-property-decorator'

@Component
export default class ArtistSearch extends Vue {
    @Prop()
    artists !: any
    @Prop({default: false})
    more !: boolean

}
